import dayjs from 'dayjs'

/**
 * Structural equality for form values, treating any two date-likes (Dayjs,
 * Date, or a parseable string) as equal when they fall on the same day.
 *
 * Moved from `src/utils/function.ts` (#59), which re-exports it, so an
 * extracted module can use it without importing that file and everything it
 * drags in. Only change: the day comparison calls `dayjs(x).format(…)`
 * directly instead of `formatDateWithFormatter(x, 'DD/MM/YYYY')`, which for
 * these arguments (no `fromUTC`, and a date-like is never falsy) is exactly
 * that call.
 */
export function deepEqual(a: any, b: any): boolean {
    if (a === b) return true

    const isDateLike = (val: any) =>
        dayjs.isDayjs(val) ||
        Object.prototype.toString.call(val) === '[object Date]' ||
        (typeof val === 'string' && dayjs(val).isValid())
    if (isDateLike(a) && isDateLike(b)) {
        return dayjs(a).format('DD/MM/YYYY') === dayjs(b).format('DD/MM/YYYY')
    }

    if (
        typeof a !== 'object' ||
        typeof b !== 'object' ||
        a === null ||
        b === null
    ) {
        return false
    }

    const keysA = Object.keys(a)
    const keysB = Object.keys(b)

    if (keysA.length !== keysB.length) return false

    for (const key of keysA) {
        if (!keysB.includes(key)) return false
        if (!deepEqual(a[key], b[key])) return false
    }

    return true
}
